import type { PreProcessedData } from "@/api/studio/data/types/pre-processed-data.type";
import type { Region } from "@/api/studio/data/types/region.type";

// Normalize region priorities to ensure all regions have a defined priority value, defaulting to 0 if not set
export const normalizeRegions = (regions?: Region[]) =>
  regions?.map((region) => ({
    ...region,
    priority: region.priority ?? 0,
  }));

// Normalize assets by normalizing the regions within each asset
export const normalizeAssets = (assets: PreProcessedData[]) =>
  assets.map((asset) => ({
    ...asset,
    regions: normalizeRegions(asset.regions),
  }));
